<div class="dialog-wrapper dialog-confirm-wrapper">
    <div class="dialog">
        <h3 mat-dialog-title class="dialog__header">
            {{title}}
        </h3>

        <div mat-dialog-content class="dialog__content">
            <p>{{message}}</p>
        </div>

        <div mat-dialog-actions class="dialog__actions">
            <button class="btn btn-danger-outline" (click)="onDismiss()">Cancel</button>
            <button class="btn btn-default" (click)="onConfirm()">Confirm</button>
        </div>
    </div>
</div>